<script lang="ts">
  import { observeTagOverflow } from "../../../../../../../_shared/_logic/tag-overflow"
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import {
    buildRichTooltip,
    tooltipText,
    RICH_TOOLTIP_CLASS,
  } from "../../../../../../../../../_shared/_logic/rich-tooltips"
  import type { ContactOrderPlanRow } from "../../../../_logic/communication-plan-table-contract"

  let { row }: { row: ContactOrderPlanRow } = $props()
  let overflowing = $state(false)
</script>

{#if row.work}
  <span
    class="work-cell"
    aria-label={row.work.ariaLabel}
    use:observeTagOverflow={(value) => {
      overflowing = value
    }}
  >
    <StatusTag
      variant="neutral"
      size="sm"
      status={row.work.status}
      subLabel={row.work.subLabel}
      iconText={row.work.orderNumber}
      tooltipContent={buildRichTooltip([
        overflowing
          ? tooltipText([row.work.status.label, row.work.subLabel].filter(Boolean).join(" · "))
          : null,
        row.work.tooltipHtml,
      ])}
      tooltipHtml={true}
      tooltipClassName={RICH_TOOLTIP_CLASS}
      disableTitle={true}
    />
  </span>
{:else}
  <span class="work-cell work-cell--empty">–</span>
{/if}

<style lang="less">
  .work-cell {
    display: inline-flex;
    max-width: 23rem;

    :global(.status-tag) {
      max-width: 100%;
    }

    :global(.status-tag__main-label),
    :global(.status-tag__sub-label) {
      max-width: 18rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .work-cell--empty {
    color: color-mix(in srgb, var(--text-invers-100) 72%, transparent);
  }
</style>
